class WarehouseLevel {
    /**
     * @type {string}
     */
    id;

    /**
     * @type {string}
     */
    name;

    /**
     * @type {WarehouseLevel[]}
     */
    children;

    /**
     * @type {WarehouseStorage | undefined}
     */
    storage;

    /**
     * @type {string[]}
     */
    ancestorNames;

    /**
     * @type {string}
     */
    ancestorNamesFormatted;

    /**
     * Checks if this level matches a search string
     * @param query {string}
     * @return {boolean}
     */
    matches = (query) => {
        return !!(
            this.name.toLowerCase().includes(query.toLowerCase()) ||
            this.ancestorNames.join(' ').toLowerCase().includes(query.toLowerCase()) ||
            (this.storage && this.storage?.product.name.toLowerCase().includes(query.toLowerCase()))
        );
    }

    /**
     * @returns {string}
     */
    get sortingIdentifier() {
        return `${this.ancestorNames.map(name => name[0]).join('')}${this.name}`;
    }

    constructor(dto) {
        this.id = dto.id;
        this.name = dto.name;
        this.children = dto.children ? dto.children.forEach(subLevel => new WarehouseLevel(subLevel)) : [];
        if(dto.storage) {
            this.storage = new WarehouseStorage(dto.storage);
        }
        this.ancestorNames = dto.ancestorNames;
        this.ancestorNamesFormatted = dto.ancestorNames.join(' ➟ ');

    }

}

module.exports.WarehouseLevel = WarehouseLevel;

class WarehouseStorage {
    /**
     * @type {string}
     */
    id;

    /**
     * @type {WarehouseProduct}
     */
    product;

    /**
     * @type {ProductUnit}
     */
    units;

    /**
     * @type {number}
     */
    stocked;

    /**
     * @type {number}
     */
    minStock;

    /**
     * @type {number}
     */
    maxStock;

    constructor(dto) {
        this.id = dto.id;
        this.product = new WarehouseProduct(dto.product);
        this.units = new ProductUnit(dto.units);
        this.stocked = dto.stocked;
        this.minStock = dto.minStock;
        this.maxStock = dto.maxStock;
    }
}

module.exports.WarehouseStorage = WarehouseStorage;

class WarehouseProduct {
    /**
     * @type {string}
     */
    id;
    /**
     * @type {string}
     */
    name;
    /**
     * @type {string}
     */
    description;

    /**
     * @type {WarehouseProductAdditionalInformation[]}
     */
    additionalInformation = [];

    constructor(dto) {
        this.id = dto.product.id;
        this.name = dto.product.description.name;
        this.description = dto.product.description.text;
        for(const supplierInfo of dto.product.suppliers) {
            this.additionalInformation.push(new WarehouseProductAdditionalInformation(
                supplierInfo.supplierCompanyId,
                supplierInfo.supplierArtNo,
                supplierInfo.supplierName
            ));
        }
    }
}

module.exports.WarehouseProduct = WarehouseProduct;

class WarehouseProductAdditionalInformation {

    static DTO_KEY = {
        supplierId: 'supplierCompanyId',
        supplierArticleNumber: 'supplierArtNo'
    }

    /**
     * @type {string}
     */
    supplierId;

    /**
     * @type {string}
     */
    supplierArticleNumber;

    /**
     * @type {string}
     */
    supplierName;


    constructor(supplierId, supplierArticleNumber, supplierName) {
        if (supplierId) {
            this.supplierId = supplierId;
        }
        if (supplierArticleNumber) {
            this.supplierArticleNumber = supplierArticleNumber;
        }
        if (supplierName) {
            this.supplierName = supplierName;
        }
    }
}

module.exports.WarehouseProductAdditionalInformation = WarehouseProductAdditionalInformation;

class ProductUnit {
    /**
     * @type {string}
     */
    orderUnit;

    /**
     * @type {string}
     */
    contentUnit;

    /**
     * @type {number}
     */
    contentUnitsPerOrderUnit;

    constructor(dto) {
        this.orderUnit = dto.orderUnit;
        this.contentUnit = dto.contentUnit;
        this.contentUnitsPerOrderUnit = dto.contentUnitsPerOrderUnit;
    }
}

module.exports.ProductUnit = ProductUnit;